import axios from "axios";

export default function PurchaseorderStatusListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/purchase_order_status",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
